/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LifestyleFactorValue
 */
export interface LifestyleFactorValue {
    /**
     * 
     * @type {string}
     * @memberof LifestyleFactorValue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LifestyleFactorValue
     */
    details?: string;
    /**
     * 
     * @type {string}
     * @memberof LifestyleFactorValue
     */
    notes?: string;
}

/**
 * Check if a given object implements the LifestyleFactorValue interface.
 */
export function instanceOfLifestyleFactorValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function LifestyleFactorValueFromJSON(json: any): LifestyleFactorValue {
    return LifestyleFactorValueFromJSONTyped(json, false);
}

export function LifestyleFactorValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): LifestyleFactorValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function LifestyleFactorValueToJSON(value?: LifestyleFactorValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'details': value.details,
        'notes': value.notes,
    };
}

